import { flatten } from '@utils/arrayUtils';

export const getOppositeActionType = (type) => {
  switch (type) {
    case 'unload':
      return 'load';
    case 'load':
      return 'unload';
    case 'attachTransportEquipment':
      return 'detachTransportEquipment';
    case 'detachTransportEquipment':
      return 'attachTransportEquipment';
    default:
      return type;
  }
};

export const updateConsignmentActions = (consignment, actions) => {
  const newConsignment = { ...consignment };
  newConsignment.actions = actions.filter((action) => !action.entity.isChild);

  const updateGoods = (goods, actions) => {
    goods?.length > 0
      ? [...goods]
          .map((association) => association.entity)
          .map((good) => {
            const newGood = { ...good };
            newGood.actions = actions.filter(
              (action) => action.entity.childOfNonce === (good.id || good.nonce)
            );

            newGood.containedGoods = updateGoods(newGood.containedGoods, actions);
            return newGood;
          })
      : [];
  };

  newConsignment.goods = updateGoods(newConsignment.goods, actions);
  return newConsignment;
};

export const consignmentGetAllChildActions = (consignment) => {
  return consignment?.goods?.length > 0
    ? getActionsFromGoods(consignment?.goods?.map((good) => good.entity))
    : [];
};

export const getActionsFromGoods = (goods) => {
  return goods?.map((good) =>
    flatten([
      ...(good?.actions?.length > 0
        ? good?.actions?.map((action) => {
            action.entity.isChild = true;
            action.entity.childOfNonce = good.id || good.nonce;
            return action;
          })
        : []),
      ...(good?.containedGoods?.length > 0
        ? getActionsFromGoods(good.containedGoods?.map((good) => good.entity))
        : []),
    ])
  );
};

export const copyToNewAndReverse = (action, index = 0) => ({
  ...action,
  lifeCycle: 'requested',
  id: _,
  nonce: _,
  versionNumber: _,
  sequenceNr: index - 1,
  actions: action.actions.map((innerAction) => ({
    associationType: 'inline',
    entity: {
      ...innerAction.entity,
      type: getOppositeActionType(innerAction.entity.type),
      id: _,
      nonce: _,
      versionNumber: _,
      constraints: innerAction.entity.constraints.map((constraint) => ({
        associationType: 'inline',
        entity: {
          ...constraint.entity,
          id: _,
          nonce: _,
          versionNumber: _,
          value: {
            ...constraint.entity.value,
            id: _,
            nonce: _,
            versionNumber: _,
          },
        },
      })),
    },
  })),
  constraints: action.constraints.map((constraint) => ({
    associationType: 'inline',
    entity: {
      ...constraint.entity,
      id: _,
      nonce: _,
      versionNumber: _,
      value: {
        ...constraint.entity.value,
        id: _,
        nonce: _,
        versionNumber: _,
      },
    },
  })),
});

export const getToBePlannedActions = (consignments) => {
  return flatten(
    consignments.map((consignment, index) => {
      const actions = [...consignment.actions, ...consignmentGetAllChildActions(consignment)].map(
        (action) => {
          const newAction = { ...action };
          const newEntity = { ...newAction.entity };

          newEntity.sequenceNr = index + newEntity?.sequenceNr;
          newAction.entity = newEntity;
          return newAction;
        }
      );
      const goodsActions = flatten(
        consignment.goods.map((goods) =>
          goods.entity.actions.map((action) => {
            const newAction = { ...action };
            const newEntity = { ...action.entity };

            newEntity.sequenceNr = index + action.entity.sequenceNr;
            newAction.entity = newEntity;
            return newAction;
          })
        )
      );

      // add previous location
      if (
        !['accepted', 'confirmed'].includes(consignment.status) &&
        (consignment.lastAction || consignment.lastPlannedAction)
      ) {
        actions.push({
          associationType: 'inline',
          entity: {
            ...copyToNewAndReverse(consignment.lastAction || consignment.lastPlannedAction, index),
            startTime: null,
            endTime: null,
            lifeCycle: 'requested',
          },
        });
      }
      return actions.concat(goodsActions);
    })
  )
    .filter((action) => action.entity.lifeCycle === 'requested')
    .sort((a, b) => a.entity.sequenceNr - b.entity.sequenceNr);
};
